export default __webpack_public_path__ + "assets/google-icon-f10f2f9c555cbf793bac88b58b155508.svg";